export const email = "kamil.justynski1998@gmail.com";
